<template>
    <span>
      <span v-if="status === 'paid'">Opłacono</span>
      <v-btn flat color="primary" v-if="status !== 'paid' && isActiveRunner" :to="{name: 'runner-payments-pay', params: {id: runner_id, payment_id: id}}">Zapłać</v-btn>
      <span v-if="status !== 'paid' && !isActiveRunner">Nieopłacono</span>
    </span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['status', 'id', 'runner_id'],
  computed: {
    'statusDisplay': function () {
      let value = this.status
      if (value === 'paid') {
        return 'Opłacono'
      } else if (value === 'exceeded') {
        return 'Termin przekroczony'
      } else if (value === 'unpaid') {
        return 'Nieopłacone'
      }
      return ''
    },
    ...mapGetters(['isActiveRunner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/RunnerPaymentStatus.vue